export default {
    defaultWfpTitle: "SPOC",
    defaultChatTitle: "Chat with operator",
    defaultWfpHeaderPrivacy: 'The conversation will be saved for quality purposes. For more details, see the <a href="https://www.wfp.it/privacy/" target="_blank">privacy</a> section',
    defaultPrivacyMessage: `
    Hello,
    <br />
    please be informed that this chat uses an artificial intelligence system, in some cases generative, to respond accurately, quickly, and efficiently to your requests. Privacy notice at <a href="https://www.wfp.it/wfp-chat-privacy/" target="_blank">this link</a>.
    <br /><br />
    Additionally, to provide you with a personalized service and more effective responses via chatbot, do you authorize the processing of data provided within this conversation session?
  `,
    defaultWfpWelcomeMessage: "Hi, I’m Spoc, your virtual assistant.<br /> I’m here to support you on your journey with WeTravel platform. While I’m still learning, your questions help me grow and serve you better over time. For now, I can assist you with <strong>PROCEDURAL</strong> questions related to using the WeTravel platform.",
    defaultTimeoutMessage: "Dear colleague, your conversation has been inactive for a while. Would you like to continue where you left or start a new question?",
    defaultVerificationPopupText: `<strong>Spoc only answers questions about WeTravel procedures.</strong><br />
    For travel policy, please check WFPgo.<br />
    <strong>Please confirm you accept this before continuing.<strong>`,
    defaultVerificationDeclinePopupText: "Thank you for your time. Please feel free to come back whenever you have procedure-related questions.",
    verificationPopupConfirmButtonText: "I accept",
    verificationPopupDeclineButtonText: "I decline",
    defaultConversationListHeading: "CONVERSATION LIST",
    defaultCasesHistoryHeading: "CASES HISTORY",
    defaultBackToConversationListLabel: "CHAT",
    defaultAskBotLabel: "Ask SPOC",
    defaultXmppConnectionMessage: "Thanks for your patience — the chat is loading and will be ready shortly. <br/> For the best experience, make sure the chatbot is open in just one browser window.",
    defaultSelectButtonLabel: "Select first a button to carry on",
    defaultInputTextPlaceholder: "Write your message",
    defaultInputDatePlaceholder: "Insert date",
    defaultInputLocationPlaceholder: "Insert location",
    defaultPopupLocationPlaceholder: "write a position",
    defaultPopupButtonCancel: "Cancel",
    defaultPopupButtonConfirm: "Confirm",
    defaultTimeoutContinuePreviousMessage: "Continue",
    defaultTimeoutRestartMessage: "Start a new question",
    xmppErrorDefault: "Error during XMPP authentication",
    attachmentsErrorDefault: "An error occurred while uploading the file",
    attachmentsErrorNotFound: "No attachment was selected",
    attachmentsErrorExtensionNotAllowed: "The extension of the selected attachment is not supported (.jpg, .png, .gif, .tif, .doc, .docx, .pdf, .mp3, .zip, .rar)",
    attachmentsErrorFileTooBig: "The selected attachment is too large",
    attachmentsErrorInvalidConversation: "This is not a valid conversation for sending the selected attachment"
};
